/* AFW Quote Modal + SEO Cleanup — externalized from theme.liquid for HTML size reduction */
(function(){
  /* Show success notification if redirected back after form submission */
  if(window.location.search.indexOf('contact_posted=true')!==-1){
    var toast=document.createElement('div');
    toast.innerHTML='<div style="position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:999999;background:linear-gradient(135deg,#1a7a2e,#28a745);color:#fff;padding:20px 32px;border-radius:12px;font-family:Outfit,sans-serif;font-size:16px;font-weight:600;box-shadow:0 8px 30px rgba(0,0,0,0.3);display:flex;align-items:flex-start;gap:12px;animation:afw-slideDown 0.4s ease-out;max-width:520px;width:90%"><span style="font-size:24px;flex-shrink:0">\u2713</span><div><div>Quote Request Sent!</div><div style="font-size:13px;font-weight:400;opacity:0.9;margin-top:4px">We\'ll get back to you within 24 hours with confirmed pricing and availability. Prices shown on our site are estimates and may vary.</div><div style="font-size:13px;font-weight:400;opacity:0.85;margin-top:4px">Call <a href="tel:9132912027" style="color:#fff;text-decoration:underline">913-291-2027</a> for immediate help.</div></div></div>';
    document.body.appendChild(toast);
    setTimeout(function(){toast.style.transition='opacity 0.5s';toast.style.opacity='0';setTimeout(function(){toast.remove()},500)},8000);
    if(history.replaceState){history.replaceState(null,null,window.location.pathname);}
  }

  var overlay = document.getElementById('afw-quote-overlay');
  var closeBtn = document.getElementById('afw-quote-close');
  var cartData = null;
  var formBuilt = false;

  function fmtMoney(cents){return '$'+(cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}

  /* Inject form fields on first open — keeps initial HTML clean for crawlers */
  function buildForm(){
    if(formBuilt)return;
    var target=document.getElementById('afw-quote-fields');
    if(!target)return;
    target.innerHTML=
      '<div class="afw-quote-field"><label>Name <span class="afw-required">*</span></label><input type="text" name="contact[name]" id="afw-q-name" required placeholder="Your full name"></div>'+
      '<div class="afw-quote-field"><label>Email <span class="afw-required">*</span></label><input type="email" name="contact[email]" id="afw-q-email" required placeholder="you@email.com"></div>'+
      '<div class="afw-quote-field"><label>Phone <span class="afw-required">*</span></label><input type="tel" name="contact[phone]" id="afw-q-phone" required placeholder="(555) 555-5555"></div>'+
      '<div class="afw-quote-field"><label>Vehicle (Year / Make / Model)</label><input type="text" id="afw-q-vehicle" placeholder="e.g. 2024 Ford F-150"></div>'+
      '<div class="afw-quote-field"><label>Notes</label><textarea id="afw-q-notes" placeholder="Any additional details..."></textarea></div>'+
      '<button type="submit" class="afw-quote-submit" id="afw-quote-submit"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 2L11 13"/><path d="M22 2L15 22L11 13L2 9L22 2Z"/></svg> Send Quote Request</button>'+
      '<p class="afw-quote-disclaimer">Prices and availability shown on our website are estimates and may not reflect real-time inventory or final pricing. Our team will confirm exact pricing, availability, and any applicable installation costs when we follow up on your quote.</p>';
    formBuilt=true;
    /* Attach submit handler after form fields exist */
    var form=document.getElementById('afw-quote-form');
    if(form)form.addEventListener('submit',handleSubmit);
  }

  function openModal(){
    buildForm();
    fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      if(!cart.items||cart.items.length===0){
        alert('Your quote list is empty. Please add items first.');
        return;
      }
      cartData=cart;
      var itemsDiv=document.getElementById('afw-quote-items');
      var html='<div class="afw-quote-items-label">Your Items ('+cart.items.length+')</div>';
      cart.items.forEach(function(item,i){
        html+='<div class="afw-quote-item"><div class="afw-quote-item-title">'+(i+1)+'. '+item.product_title+'</div>';
        var meta=[];
        if(item.variant_title)meta.push(item.variant_title);
        meta.push('Qty: '+item.quantity);
        if(item.sku)meta.push('SKU: '+item.sku);
        meta.push(fmtMoney(item.final_line_price));
        html+='<div class="afw-quote-item-meta">'+meta.join(' &bull; ')+'</div></div>';
      });
      html+='<div class="afw-quote-total">Estimated Total: '+fmtMoney(cart.total_price)+'</div>';
      if(itemsDiv)itemsDiv.innerHTML=html;
      updateBodyField();
      var errorDiv=document.getElementById('afw-quote-error');
      if(errorDiv)errorDiv.style.display='none';
      overlay.classList.add('afw-quote-open');
      document.body.style.overflow='hidden';
    }).catch(function(){
      alert('Could not load cart. Please try again.');
    });
  }

  function updateBodyField(){
    var name=(document.getElementById('afw-q-name')||{}).value||'';
    var email=(document.getElementById('afw-q-email')||{}).value||'';
    var phone=(document.getElementById('afw-q-phone')||{}).value||'';
    var vehicle=(document.getElementById('afw-q-vehicle')||{}).value||'';
    var notes=(document.getElementById('afw-q-notes')||{}).value||'';
    var lines=['Hi,','','A customer just submitted a quote request on our website. They are requesting the items listed below. Please reach out to them as soon as possible.','','Customer Contact Information:','  Name: '+name.trim(),'  Email: '+email.trim(),'  Phone: '+phone.trim()];
    if(vehicle.trim())lines.push('  Vehicle: '+vehicle.trim());
    lines.push('','Requested Items:');
    if(cartData&&cartData.items){
      cartData.items.forEach(function(item,i){
        var title=(i+1)+'. '+item.product_title;
        if(item.variant_title)title+=' — '+item.variant_title;
        lines.push('  '+title);
        var details=['Qty: '+item.quantity];
        if(item.sku)details.push('SKU: '+item.sku);
        details.push('Website Price: '+fmtMoney(item.final_line_price));
        lines.push('     '+details.join(' | '));
      });
      lines.push('','  Estimated Website Total: '+fmtMoney(cartData.total_price));
    }
    if(notes.trim())lines.push('','Customer Notes:','  '+notes.trim());
    lines.push('','Please note: Prices and inventory on the website are not updated in real time and may differ from actual stock and pricing. Please verify current pricing and availability before confirming the quote with the customer.','','This is an automated message from americanfusionwheels.com');
    var bodyField=document.getElementById('afw-hf-body');
    if(bodyField)bodyField.value=lines.join('\n');
  }

  function handleSubmit(e){
    var name=document.getElementById('afw-q-name').value.trim();
    var email=document.getElementById('afw-q-email').value.trim();
    var phone=document.getElementById('afw-q-phone').value.trim();
    var errorDiv=document.getElementById('afw-quote-error');
    if(!name||!email||!phone){
      e.preventDefault();
      if(errorDiv){errorDiv.textContent='Please fill in all required fields.';errorDiv.style.display='block';}
      return;
    }
    document.getElementById('afw-hf-subject').value='New Quote Request from '+name;
    updateBodyField();
    var submitBtn=document.getElementById('afw-quote-submit');
    if(submitBtn){submitBtn.disabled=true;submitBtn.innerHTML='<span class="afw-quote-spinner"></span> Sending...';}
    if(errorDiv)errorDiv.style.display='none';
  }

  function closeModal(){
    overlay.classList.remove('afw-quote-open');
    document.body.style.overflow='';
  }

  closeBtn.addEventListener('click',closeModal);
  overlay.addEventListener('click',function(e){if(e.target===overlay)closeModal();});

  /* Listen for Request a Quote clicks */
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-request-quote]');
    if(btn){e.preventDefault();e.stopPropagation();openModal();}
  });
})();

/* AFW SEO cleanup — remove placeholder text from crawlable DOM */
!function(){
  /* Vehicle finder loader: clear placeholder text + set aria-hidden */
  var l=document.getElementById('afw-vf-loader');
  if(l){l.setAttribute('aria-hidden','true');var s=l.querySelector('span');if(s&&s.textContent.indexOf('Loading')>-1)s.textContent='';}
  /* Countdown: clear -- dashes + set aria-hidden */
  var cd=document.querySelector('.afw-promo-banner__countdown');
  if(cd){cd.setAttribute('aria-hidden','true');cd.querySelectorAll('.afw-promo-banner__countdown-num').forEach(function(e){if(e.textContent==='--')e.textContent=''});}
  /* Template btns: populate data-text → textContent if needed */
  var t=document.getElementById('btns_pr_temp');
  if(t){t.content.querySelectorAll('.t4s-text-pr[data-text]').forEach(function(e){e.textContent=e.getAttribute('data-text');});
    t.content.querySelectorAll('.t4s-text-pr:not([data-text])').forEach(function(e){if(e.textContent.trim())e.setAttribute('data-text',e.textContent);e.textContent='';});}
  /* Accessibility text: clear SSR content (JS already injected it) */
  var a=document.getElementById('a11y-refresh-page-message');
  if(a&&a.textContent.indexOf('Choosing')>-1){var txt=a.textContent;a.textContent='';a.setAttribute('data-msg',txt);}
}();
